export const convertCodeToLabel = (value: string): string => {
  switch (value.toLowerCase()) {
    case "czk":
      return "Kč";
    case "eur":
      return "€";
    default:
      return value;
  }
};
